var render = function () {
  var _vm$currentRound, _vm$currentRound$cont, _vm$currentRound$cont2, _vm$currentRound2, _vm$currentRound2$con;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'write-about-it'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('div', {
    staticClass: "left-image-paragraph",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$cont = _vm$currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.description,
      "src": (_vm$currentRound$cont2 = (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$con = _vm$currentRound2.contentImage) === null || _vm$currentRound2$con === void 0 ? void 0 : _vm$currentRound2$con.image.src) !== null && _vm$currentRound$cont2 !== void 0 ? _vm$currentRound$cont2 : ''
    }
  })]), _c('text-display-list', {
    attrs: {
      "text-size": _vm.textSize
    }
  }, [_vm.currentRound.title ? _c('li', {
    class: {
      title: true,
      isMobile: _vm.isMobile
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentRound.title))])]) : _vm._e(), _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('li', {
      key: step.answer,
      staticClass: "li-elem"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  })], 2)], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }